import { useEffect } from 'react'

const useIdleRefresh = () => {
    // REPLACE WITH 24hrs AFTER TESTING
    const timeout = 1000 * 60 * 60 * 24 // mili * sec * min * hr

    let idleTimer

    useEffect(() => {
        window.addEventListener('mousemove', handleEvent)
        window.addEventListener('scroll', handleEvent)
        window.addEventListener('keypress', handleEvent)
        window.addEventListener('touchstart', handleEvent)
        window.addEventListener('click', handleEvent)
    }, [])

    const handleEvent = () => {
        window.clearTimeout(idleTimer)
        idleTimer = window.setTimeout(handleIdle, timeout)
    }

    const handleIdle = () => {
        window.location.reload()
    }
}

export default useIdleRefresh
